import { render, staticRenderFns } from "./CustomerAdd.vue?vue&type=template&id=2f431f6c&scoped=true"
import script from "./CustomerAdd.vue?vue&type=script&lang=js"
export * from "./CustomerAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f431f6c",
  null
  
)

export default component.exports